module.exports = __webpack_public_path__ + "static/media/icon-start.76313305.png";